import { getError } from "helpers/error";
import {
  Controller,
  FieldPath,
  FieldValues,
  get,
  useFormContext,
} from "react-hook-form";

import PhoneField from "./PhoneField";
import { TextFieldHookFormProps, TextFieldProps } from "./PhoneField.types";

const PhoneFieldHookForm = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  defaultValue,
  rules,
  shouldUnregister,
  setPropsWithFormState,
  ...innerProps
}: TextFieldHookFormProps<TFieldValues, TName>) => {
  const { control } = useFormContext<TFieldValues>();

  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      rules={rules}
      shouldUnregister={shouldUnregister}
      control={control}
      render={(formState) => {
        const {
          field: { disabled, ref, onChange, ...innerField },
          formState: { errors },
        } = formState;
        const error = get(errors, name);
        const errorMsg = error?.message;
        const helperText =
          typeof errorMsg === "string" ? errorMsg : innerProps?.helperText;
        return (
          <PhoneField
            {...innerProps}
            {...innerField}
            inputRef={ref}
            error={!!error}
            helperText={helperText}
            disabled={
              typeof disabled === "boolean" ? disabled : innerProps.disabled
            }
            onChange={onChange as TextFieldProps["onChange"]}
            {...(setPropsWithFormState?.(formState) ?? {})}
          />
        );
      }}
    />
  );
};

export default PhoneFieldHookForm;
